import { DispatchListRequest } from "@/domain/entities/Dispatch";
import { ApiRequestList } from "@/domain/entities/MainApp";

export class DispatchEndpoint {
  getDispatchList(params: DispatchListRequest) {
    return `/hydra/v1/dispatch?${params.toQueryString()}`;
  }
  getDispatchDetail(id: number) {
    return `/hydra/v1/dispatch/${id}`;
  }
  updateDispatch() {
    return `/hydra/v1/dispatch/temporary`;
  }
  getListTemporary(params: ApiRequestList) {
    return `/hydra/v1/dispatch/temporary?${params.toQueryString()}`;
  }
  processUpdateDispatch() {
    return `/hydra/v1/dispatch`;
  }
}
